import { LoadingStateStatus, State } from 'shared/interface';

const createActionHasStatusSelector = (action: string, status: LoadingStateStatus) => {
	return (state: State) => state.loading.api[action] === status;
};

export const createIsActionLoadingSelector = (action: string) => createActionHasStatusSelector(action, 'LOADING');
